export default state => ({
  type: 'UPDATE_STATE',
  state,
});
